import { createSelector } from "reselect";

export const selectOrgnData = state => state.orgnData;

export const selectOrganisations = createSelector(
  [selectOrgnData],
  state => state.orgns
);
